import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@/components/Icon';
import { MOD } from './editorMode';
import s from './MarkdownEditor.module.css';
const TOOLS = [
    { id: 'bold', label: 'Жирный', icon: 'bold', key: 'B', toggle: true },
    { id: 'italic', label: 'Курсив', icon: 'italic', key: 'I', toggle: true },
    null,
    { id: 'heading', label: 'Заголовок', icon: 'heading', toggle: true },
    { id: 'heading3', label: 'Подзаголовок', icon: 'heading3', toggle: true },
    null,
    { id: 'bullet-list', label: 'Маркированный список', icon: 'list', toggle: true },
    { id: 'ordered-list', label: 'Нумерованный список', icon: 'list-ordered', toggle: true },
    { id: 'quote', label: 'Цитата', icon: 'quote', toggle: true },
    { id: 'code-block', label: 'Блок кода', icon: 'code-block', toggle: true },
    null,
    { id: 'link', label: 'Ссылка', icon: 'link', key: 'K', toggle: true },
    { id: 'image', label: 'Картинка', icon: 'image' },
    { id: 'table', label: 'Таблица', icon: 'table' },
];
/**
 * The editor's top row, the same in both modes: formatting on the left (lit up
 * where the caret is, when the mode can tell), the mode switch on the right.
 */
export function EditorToolbar({ active, off, disabled, images, onTool, controls, children, }) {
    return (_jsxs("div", { className: s.toolbar, children: [_jsxs("div", { className: s.toolRow, children: [_jsx("div", { className: s.formatTools, role: "toolbar", "aria-label": "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435", children: TOOLS.map((tool, index) => {
                            if (!tool)
                                return _jsx("span", { className: s.divider, "aria-hidden": "true" }, `divider-${index}`);
                            if (tool.id === 'image' && !images)
                                return null;
                            // Lit only for what the caret is in; an action (table, picture) never is.
                            const on = !!tool.toggle && !!active?.[tool.id];
                            return (_jsx("button", { type: "button", className: s.toolButton, "aria-label": tool.label, "aria-pressed": active && tool.toggle ? on : undefined, "data-on": on || undefined, title: tool.key ? `${tool.label} · ${MOD}${tool.key}` : tool.label, disabled: disabled || !!off?.[tool.id], onMouseDown: (event) => event.preventDefault(), onClick: () => onTool(tool.id), children: _jsx(Icon, { name: tool.icon, size: 16 }) }, tool.id));
                        }) }), _jsx("div", { className: s.viewTools, children: controls })] }), children] }));
}
